module.exports = __webpack_public_path__ + "c99a443ea495e7f0a9ad3edc175e4db3.png";